<template>
  <div>
    <div class="cursor-pointer rounded border border-gray-500 text-gray-500 hover:bg-red-500 hover:border-red-500 hover:text-white st-all p-1" @click="showNav()" style="max-width:34px"><action-icons icon="menu" /></div>
    <transition name="fade">
      <div class="fixed h-screen w-full inset-0 z-40" style="background-color: rgba(0,0,0,0.86)" v-show="navShown" key="main-nav">
        <transition name="nav-slide">
          <div class="bg-white h-screen overflow-scroll relative" id="main-menu" key="menu-holder" v-if="menuShown" v-click-outside="hideNav">
            <div class="absolute w-full border-b bg-white top-0 leading-none">
              <div class="inline-block p-2 hover:text-red-500 cursor-pointer" @click="hideNav()"><action-icons icon="arrow-left" /></div>
            </div>
            <p class="font-light text-sm text-gray-500 px-2 mt-1">Nuestras categorías</p>
            <main-nav-item
              :category="category"
              :key="`cat-${category.slug}`"
              v-for="category in categories" />

<!--             <div class="lg:hidden mt-4 ml-2"><a href="https://www.serviciosonline.omnisport.com/home/solicitudTeleventa" class="bt yellow" target="_blank">Solicita tu crédito aquí</a></div>
            <div class="lg:hidden mt-4 ml-2"><a href="https://www.serviciosonline.omnisport.com/" class="bt main" target="_blank">Paga aquí tus cuentas</a></div> -->

            <div class="mt-8 md:hidden" v-if="pages.length > 0">
              <p class="font-light text-sm text-gray-500 px-2 mt-1">Sitio web</p>
              <a class="block p-2 border-b hover:bg-gray-100 cursor-pointer" href="/tiendas">Nuestras tiendas</a>
              <a class="block p-2 border-b hover:bg-gray-100 cursor-pointer" href="/marcas">Nuestras Marcas</a>
              <a class="block p-2 border-b hover:bg-gray-100 cursor-pointer" href="/zonas-de-cobertura">Zonas de cobertura</a>
              <a class="block p-2 border-b hover:bg-gray-100 cursor-pointer" href="/politicas-de-cambio-y-devolucion">Políticas de Cambio y Devolución</a>
              <a class="block p-2 border-b hover:bg-gray-100 cursor-pointer" href="/contacto">Contáctanos</a>
              <a
                class="block p-2 border-b hover:bg-gray-100 cursor-pointer"
                :key="`page-${i}`"
                :href="`/${page.slug}`"
                v-for="(page, i) in pages">{{ page.title }}</a>
            </div>

            <div class="md:hidden text-sm p-2 mt-5">
              NIC: <a href="tel:50322982755 " target="_blank" class="link-basic">(503) 2298-2755 </a><br>NIC/CANADÁ: <a href="tel:18003153544" target="_blank" class="link-basic">1-800-315-3544</a>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
import MainNavItem from "./MainNavItem";
export default {
  name: 'main-nav',
  directives: { 'click-outside': onClickaway },
  components: { MainNavItem },
  props: {
    categories: {
      type: Array,
      default() {
        return [];
      }
    },
    pages: {
      type: Array,
      default() {
        return [];
      }
    },
    showBranches: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navShown: false,
      menuShown: false,
      smallRes: false,
    }
  },
  mounted ()
  {
    document.body.addEventListener('keyup', this.escKeyUpFunction);
    window.addEventListener('resize', this.callCheckRes);
    this.checkRes();
  },
  methods: {
    showNav()
    {
      document.body.classList.add('overflow-hidden');
      this.navShown = true;
      setTimeout(() => {
        this.menuShown = true;
      }, 100);
    },
    hideNav ()
    {
      document.body.classList.remove('overflow-hidden');
      this.menuShown = false;
      setTimeout(() => {
        this.navShown = false;
      }, 100);
    },
    escKeyUpFunction(e)
    {
      if (e.keyCode === 27) {
        this.hideNav();
      }
    },
    /**
      * Calls the check-resolution method
      */
      callCheckRes()
      {
        this.checkRes();
      },
      /**
       * Checks the window resolution in order to determine if it's a small one
       */
      checkRes()
      {
        this.smallRes = (window.innerWidth < 640);
      },
  }
}
</script>
<style scoped>
#main-menu {
  width: 100%;
  max-width: 350px;
  padding-top: 50px;
}
</style>